// extracted by mini-css-extract-plugin
export default {"main":"Login_main__N0N1C"};